import { regionalClient } from "../../../.."
import { CreateSystemConfiguration } from "../../../models/CreateSystemConfiguration"
import { InitializationEndpoints } from "../../../modules/api/endpoints/InitializationEndpoints"

export const createSystemInitialConfig = (payload : CreateSystemConfiguration) => {
  return regionalClient.post(InitializationEndpoints.createSystemInitialConfig, payload)
}
